module.exports = __webpack_public_path__ + "static/media/10.958db347.jpg";